document.addEventListener('DOMContentLoaded', () => {
  const selector = [
    '.ad-editorial-home .media',
    '.ad-editorial-home .ad-hero__image',
    '.ad-editorial-home .ad-category__image',
    '.ad-editorial-home .ad-story__image',
    '.ad-editorial-home .ad-wholesale__image',
    '.ad-editorial-home .ad-studio-still',
    '.ad-editorial-home .ad-manifesto',
    '.ad-editorial-home .ad-category__copy',
    '.ad-editorial-home .ad-trust > div',
    '.ad-story__copy',
    '.card-wrapper'
  ].join(',');

  const targets = Array.from(document.querySelectorAll(selector));
  targets.forEach((el) => el.classList.add('ad-reveal'));

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    targets.forEach((el) => el.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.08,
    rootMargin: '0px 0px -8% 0px'
  });

  targets.forEach((el) => observer.observe(el));
});
